module.exports = __webpack_public_path__ + "static/media/video-player.1c31228c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/video-player.svg
// module id = 911
// module chunks = 0